/**
 * Documento e rodapé do Beefree no cliente.
 * As frases de licença espelham server/lib/beefree.ts. Quem decide se a env existe é o BFF.
 */

export const BEEFREE_NOT_CONFIGURED = 'beefree_not_configured';
export const BEEFREE_IMPORTER_NOT_CONFIGURED = 'beefree_importer_not_configured';

export const BEEFREE_NOT_CONFIGURED_MESSAGE =
  'O editor Beefree entra com a licença no servidor. Configure BEEFREE_CLIENT_ID e BEEFREE_CLIENT_SECRET no BFF, sem prefixo VITE_, para o segredo não ir ao navegador.';

export const BEEFREE_IMPORTER_NOT_CONFIGURED_MESSAGE =
  'Importar HTML para o Beefree usa a HTML Importer API. Configure BEEFREE_HTML_IMPORTER_KEY no servidor. Sem essa chave o documento não é aberto.';

export interface BeefreeDocument {
  page: Record<string, unknown>;
  comments: Record<string, unknown>;
}

const UNSUBSCRIBE_FOOTER =
  '<p style="margin:24px 0 0;padding-top:16px;border-top:1px solid #e4e4e7;font-family:sans-serif;font-size:12px;line-height:1.5;text-align:center;"><a href="{{unsubscribe}}" style="color:#3f3f46;text-decoration:underline;">Cancelar inscrição</a></p>';

export function htmlHasUnsubscribe(html: string): boolean {
  return /unsubscribe|descadast|cancelar inscri|opt-?out/i.test(html);
}

/** Garante um único rodapé de descadastro no HTML que o Beefree devolveu. */
export function ensureUnsubscribeFooter(html: string): string {
  const source = html.trim();
  if (!source || htmlHasUnsubscribe(source)) return html;
  if (/<\/body>/i.test(source)) return source.replace(/<\/body>/i, `${UNSUBSCRIBE_FOOTER}</body>`);
  return `${source}\n${UNSUBSCRIBE_FOOTER}`;
}

export function normalizeBeefreeDocument(value: unknown): BeefreeDocument | null {
  if (!value || typeof value !== 'object') return null;
  const record = value as Record<string, unknown>;
  if (record.page && typeof record.page === 'object') {
    const comments =
      record.comments && typeof record.comments === 'object' ? (record.comments as Record<string, unknown>) : {};
    return { page: record.page as Record<string, unknown>, comments };
  }
  if (record.data && typeof record.data === 'object') {
    const data = record.data as Record<string, unknown>;
    if (data.json) return normalizeBeefreeDocument(data.json);
  }
  if (
    Array.isArray(record.rows) &&
    record.body &&
    typeof record.body === 'object' &&
    record.template &&
    typeof record.template === 'object'
  ) {
    return { page: record, comments: {} };
  }
  return null;
}

export function parseBeefreeDocument(raw: string): BeefreeDocument | null {
  if (!raw.trim()) return null;
  try {
    return normalizeBeefreeDocument(JSON.parse(raw) as unknown);
  } catch {
    return null;
  }
}

export function readBeefreeBoot(state: unknown): { beefreeJson: string; html: string } | null {
  if (!state || typeof state !== 'object') return null;
  const record = state as Record<string, unknown>;
  if (typeof record.beefreeJson !== 'string' || !record.beefreeJson.trim()) return null;
  if (!parseBeefreeDocument(record.beefreeJson)) return null;
  return {
    beefreeJson: record.beefreeJson,
    html: typeof record.html === 'string' ? record.html : '',
  };
}

export function blankBootId(state: unknown): number | null {
  if (!state || typeof state !== 'object' || !('blank' in state)) return null;
  const blank = (state as { blank?: unknown }).blank;
  return typeof blank === 'number' ? blank : null;
}
